import { useEffect, useState } from "react";
import { useSettings } from "@/lib/useSettings";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Save } from "lucide-react";

export default function FooterSettings() {
  const { data, save } = useSettings();
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  if (!f) return <div className="text-slate-400">Lädt…</div>;

  return (
    <div className="max-w-xl">
      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Footer-Einstellungen</h2>
        <p className="text-sm text-slate-500">Wird auf der Login-Seite und in der App-Ansicht angezeigt.</p>
        <div><Label>Footer-Text</Label><Textarea value={f.footer_text} onChange={(e) => setF({ ...f, footer_text: e.target.value })} className="mt-1" rows={2} data-testid="footer-text" /></div>
        <div><Label>Versionsnummer</Label><Input value={f.version} onChange={(e) => setF({ ...f, version: e.target.value })} className="mt-1 w-40 mono" placeholder="V1.0" /></div>
        <Button onClick={() => save({ footer_text: f.footer_text, version: f.version })} className="bg-[#0B132B] hover:bg-[#1C2541]"><Save size={16} className="mr-1.5" /> Speichern</Button>
      </div>
    </div>
  );
}
